import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

const RightPanel = ({ children }) => {
    return (
        <div className='right'>
            <Container fluid className='my-5'>
                <Row className='justify-content-center'>
                    <Col xs={12}>
                        {children}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default RightPanel